/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface ICheckoutLoyaltyInput {
    className: string;
    type: string;
    value: string | number;
    min: number;
    max: number;
    ariaValueMax: number;
    ariaValueMin: number;
    ariaValueNow: number;
    id: string;
    step: string;
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
    onBlur(event: React.FocusEvent<HTMLInputElement>): void;
}

const AdressInput: React.FC<ICheckoutLoyaltyInput> = ({
    className,
    type,
    value,
    min,
    max,
    step,
    ariaValueMax,
    ariaValueMin,
    ariaValueNow,
    onChange,
    onBlur,
    id
}) => (
    <input
        className={className}
        type={type}
        value={value}
        min={min}
        max={max}
        step={step}
        aria-valuemax={ariaValueMax}
        aria-valuemin={ariaValueMin}
        aria-valuenow={ariaValueNow}
        onChange={onChange}
        onBlur={onBlur}
        id={id}
    />
);

export default AdressInput;
